let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2qNkd")).then(() => parcelRequire('jl05c'));